import { TApplicationState } from '../../types/redux';
import { selectFormFields } from '../formFields';

export const selectSuburbanFormValues = (state: TApplicationState) => {
  const formFields = selectFormFields(state);

  return {
    category: formFields.category,
    address: formFields.address,
    houseArea: formFields.houseArea,
    landArea: formFields.landArea as number,
    isNeedChatSubscribe: formFields.isChatSubscribeActive,
  };
};
